module.exports = __webpack_public_path__ + "img/message-sent.icon.b8da578f.png";